import { logger } from '../../../../utils/logger';
import { isMemberSignedIn } from '../../selectors/member/is-member-signed-in';
import { loadMember } from './load-member';
export const loadMemberIfSignedIn = async (reloadCachedData = false) => {
    if (!isMemberSignedIn()) {
        logger.info('Cannot load member when user is not signed in.');
        return;
    }
    return loadMember(reloadCachedData);
};
//# sourceMappingURL=load-member-if-signed-in.js.map